// extracted by mini-css-extract-plugin
export default {"header":"hK-z","isActive":"iK-z"};